import { Text, View } from "@react-pdf/renderer";
import PDFHorizontalTable from "components/PDF/Table/HorizontalTable";
import { BalancoFinanceiroPdfResponse } from "core/features/relatorios/typings";
import { useMovimentacaoContasBancariasTableRows } from "./hooks/useMovimentacaoContasBancariasTableRows";

interface MovimentacaoContasBancariasProps {
  data: BalancoFinanceiroPdfResponse;
}

export default function MovimentacaoContasBancarias({
  data,
}: MovimentacaoContasBancariasProps) {
  const rows = useMovimentacaoContasBancariasTableRows();
  return (
    <View>
      <Text
        style={{
          textAlign: "center",
          fontSize: 10,
          fontWeight: "bold",
          marginVertical: 4,
        }}
      >
        CONTAS BANCÁRIAS
      </Text>

      {data?.contasBancarias?.map((conta) => (
        <View style={{ marginBottom: 2 }} key={conta.id}>
          <PDFHorizontalTable
            data={conta}
            totalRow={conta.total}
            key={conta.id}
            title={conta.nome}
            rows={rows}
          />
        </View>
      ))}
    </View>
  );
}
